module.exports = __webpack_public_path__ + "static/img/LOGO_VGROUP_HONDA_RED.ea678d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LOGO_VGROUP_HONDA_RED.png
// module id = 6Hm3
// module chunks = 2